import { navLinks } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-background-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-base" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-200">快手黑料</span>
            </div>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-400">
              汇总快手事件辟谣反转、当事人回应与后续进展，复盘公关动态，帮你对照核实、避免被单方面说法带偏。
            </p>
            <div className="mt-4 flex items-center gap-2 text-foreground-400">
              <i className="ri-time-line text-base" />
              <span className="text-xs">更新频率：随公开信息持续跟进 · 口径每日刷新</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-200">版块直达</h4>
            <ul className="mt-3 space-y-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-400 transition hover:text-foreground-200">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-200">建议的阅读顺序</h4>
            <ul className="mt-3 space-y-2 text-sm text-foreground-400">
              <li>先看事件追踪里的状态标签</li>
              <li>再对照辟谣核查清单的结论</li>
              <li>用反转复盘理解事件走向</li>
              <li>最后读当事人回应与公关复盘</li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-200">关注动态</h4>
            <p className="mt-3 text-xs leading-relaxed text-foreground-500">
              订阅站点更新提醒，第一时间看到辟谣反转与后续进展的刷新。
            </p>
            <button
              type="button"
              className="mt-3 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-950 transition hover:bg-accent-600"
            >
              <i className="ri-notification-3-line text-base" />
              开启追踪提醒
            </button>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-900/60 pt-5 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 快手黑料 · 内容为公开信息整理的状态示意，不构成事实认定，请以官方渠道信息为准。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line text-secondary-600" /> 核实优先
            </span>
            <a href="#faq" className="transition hover:text-foreground-200">免责说明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}